import { useCallback } from "preact/hooks";
import { useApp } from "~/core/store";

const useAccessCheck = () => {
    const {
        api: { service },
    } = useApp();
    const isLoading = service.loading.value;
    const isLoaded = service.loaded.value;
    const services = service.services.value;

    const check = useCallback(
        (access: readonly string[] | readonly (readonly string[])[]) =>
            !isLoading &&
            access.every((key) =>
                Array.isArray(key)
                    ? key.some((k) =>
                          services.find(
                              (service) =>
                                  k === `${service.service}.${service.method}`,
                          ),
                      )
                    : services.find(
                          (service) =>
                              key === `${service.service}.${service.method}`,
                      ),
            ),
        [isLoading, services],
    );

    return { check, isLoading, isLoaded };
};

export default useAccessCheck;
